// extracted by mini-css-extract-plugin
module.exports = {"image":"UploadImage_image__GxDOc","AnimationName":"UploadImage_AnimationName__5mjxL"};